import * as api from '@sophocles/api/siteSettings';
import { createSettingsFeature } from '@sophocles/features/_settings/createSettingsFeature';

const feature = createSettingsFeature({
  name: 'siteSettings',
  idKey: 'siteId',
  api: { fetch: api.fetchSiteSettings, patch: api.patchSiteSettings },
});

// Non-destructive: keeps cached data visible while triggering a background
// refetch (status → idle).  Use instead of invalidate when the page must stay
// rendered during the reload (e.g. feature-toggle paths that would otherwise
// blank the settings page).
export const markStaleSiteSettings = feature.actions.markStale;

// Per-section selectors — names stay greppable.  Section presence is
// itself the visibility signal; consumers should also feel free to
// read `settings.<section>` directly for `Boolean()` gating.
export const selectSiteGeneral = feature.selectSection('general');
export const selectSiteAlarms = feature.selectSection('alarms');

// Top-level + per-section hooks.
export const useSiteSettings = feature.useSettings;

export default feature.reducer;
